import React, { useEffect, useState } from "react";
import "./AddInsufficiencyVendor.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  addCompanyInsufficientEducationInfo,
  addCompanyInsufficientEmpInfo,
  vendorAddInsufficientOtherCheck,
  vendorFetchInsufficientCheckwise,
} from "../../redux/actions/CompanyInsufficiencyAction";
// import Loader from "../Loader/Loader";
import ButtonSpinner from "../ReusableComponents/ButtonSpinner";
import FullPageLoader from "../Loader/FullPageLoader";

const AddInsufficiencyIdVendor = ({
  setFillInsufficiencyDetails,
  candidateInfo,
  setTrigger,
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const insufficientCheckwiseData = useSelector(
    (state) => state.vendorFetchInsufficientCheckwise.data?.data
  );
  const addEduDetailsLoading = useSelector(
    (state) => state.addCompanyInsufficientEducationInfo.loading
  );
  const addEmpDetailsLoading = useSelector(
    (state) => state.addCompanyInsufficientEmpInfo.loading
  );
  const addOtherDetailsLoading = useSelector(
    (state) => state.vendorAddInsufficientOtherCheck.loading
  );
  const loading =
    addEduDetailsLoading || addEmpDetailsLoading || addOtherDetailsLoading;
  const getCheckDetailsLoading = useSelector(
    (state) => state.vendorFetchInsufficientCheckwise.loading
  );
  const isPanCheck = candidateInfo?.serviceprovider_id === "CLIENT_1234";
  const isAadharCheck = candidateInfo?.serviceprovider_id === "CLIENT_1235";
  const isDlCheck = candidateInfo?.serviceprovider_id === "CLIENT_1236";
  const isVoterCheck = candidateInfo?.serviceprovider_id === "CLIENT_1237";
  const isPassportCheck = candidateInfo?.serviceprovider_id === "CLIENT_1238";
  const isBankCheck = candidateInfo?.serviceprovider_id === "CLIENT_1239";
  const isUanCheck = candidateInfo?.serviceprovider_id === "CLIENT_1241";

  useEffect(() => {
    const successFn = (res) => {
      console.log("res", res);
    };
    const failureFn = (err) => {
      console.log("fail", err);
      alert(err);
      // setFillInsufficiencyDetails(false);
    };
    dispatch(
      vendorFetchInsufficientCheckwise({
        data: candidateInfo,
        successFn,
        failureFn,
      })
    );
  }, []);

  useEffect(() => {
    setFiles([]);
    if (isPanCheck) {
      setFormData(insufficientCheckwiseData?.pan_docs);
      setFiles([insufficientCheckwiseData?.pan_docs?.pan_docs_url]);
    } else if (isAadharCheck) {
      setFormData(insufficientCheckwiseData?.aadhar_docs);
      setFiles([insufficientCheckwiseData?.aadhar_docs?.aadhar_docs_url]);
    } else if (isDlCheck) {
      setFormData(insufficientCheckwiseData?.driving_license_docs);
      setFiles([
        insufficientCheckwiseData?.driving_license_docs
          ?.driving_license_docs_url,
      ]);
    } else if (isVoterCheck) {
      setFormData(insufficientCheckwiseData?.voterid_docs);
      setFiles([insufficientCheckwiseData?.voterid_docs?.voterid_docs_url]);
    } else if (isPassportCheck) {
      setFormData(insufficientCheckwiseData?.passport_docs);
      setFiles([insufficientCheckwiseData?.passport_docs?.passport_docs_url]);
    } else if (isBankCheck) {
      setFormData(insufficientCheckwiseData?.bankverification_docs);
      setFiles([
        insufficientCheckwiseData?.bankverification_docs
          ?.bankverification_docs_url,
      ]);
    } else if (isUanCheck) {
      setFormData(insufficientCheckwiseData?.uan_docs);
      setFiles([insufficientCheckwiseData?.uan_docs?.uan_docs_url]);
    }
  }, [insufficientCheckwiseData]);

  const generateYears = (numYears = 100) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: numYears }, (_, i) => currentYear - i);
  };

  const months = [
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];

  const years = generateYears();

  const handleChange = (e) => {
    setIsEdited(true);
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setIsEdited(true);
    const selectedFiles = Array.from(e.target.files);
    setFiles([...files, ...selectedFiles]);
  };

  const addOtherInsuff = (data) => {
    const successFn = (res) => {
      console.log(res);
      alert(res.message);
      setFillInsufficiencyDetails(false);
      setTrigger();
    };
    const failureFn = (err) => alert(err);
    dispatch(vendorAddInsufficientOtherCheck({ data, successFn, failureFn }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const notEditedAlert = () => {
      if (!isEdited) {
        alert("Please edit or add required files");
        return false;
      }
      return true;
    };
    const formDatatoSend = new FormData();
    const removeKeys = (obj, keysToRemove) => {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (!keysToRemove.includes(key)) {
          acc[key] = value;
        }
        return acc;
      }, {});
    };
    const urlFiles = files.filter((file) => typeof file === "string");
    formDatatoSend.append("identity_url", JSON.stringify(urlFiles));

    if (insufficientCheckwiseData?.is_document_missing === 1) {
      const uploadedFiles = files.filter((file) => typeof file === "object");
      uploadedFiles.forEach((file) => {
        formDatatoSend.append("identity_file", file);
      });
    }
    const keysToRemove = [
      "pan_docs_url",
      "aadhar_docs_url",
      "driving_license_docs_url",
      "voterid_docs_url",
      "passport_docs_url",
      "bankverification_docs_url",
      "uan_docs_url",
    ];
    const idFormData = removeKeys(formData, keysToRemove);

    formDatatoSend.append(
      "candidate_username",
      candidateInfo.candidate_user_name
    );
    formDatatoSend.append(
      "service_provider_id",
      candidateInfo.serviceprovider_id
    );
    formDatatoSend.append("identity_json", JSON.stringify(idFormData));

    for (let [key, value] of formDatatoSend.entries()) {
      console.log(key, value);
    }
    if (
      isPanCheck ||
      isAadharCheck ||
      isDlCheck ||
      isVoterCheck ||
      isPassportCheck ||
      isBankCheck ||
      isUanCheck
    ) {
      console.log("isEdited", isEdited);
      if (!notEditedAlert()) {
        return;
      }
      addOtherInsuff(formDatatoSend);
    }
  };
  const handleDelete = (deleteInd) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== deleteInd)
    );
  };

  console.log("formData", formData);
  console.log("files", files);

  return (
    <main className='AddInsufficiencyVendor'>
      {getCheckDetailsLoading ? (
        <>
          {/* <section className='LoaderContainer'>
            <FullPageLoader />
          </section> */}
          <ButtonSpinner />
        </>
      ) : (
        <form
          className='AddDetails'
          onSubmit={handleSubmit}>
          <header>
            <h1>Insufficiency Details</h1>
            <button
              className='Close'
              onClick={() => setFillInsufficiencyDetails(false)}>
              Close
            </button>
            <button
              className='Save CenterDiv'
              type='submit'
              disabled={loading}>
              {loading ? <ButtonSpinner /> : "Save"}
            </button>
          </header>

          <section>
            {isPanCheck && (
              <>
                <h5>PAN details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='PAN Number'
                    name='pan_no'
                    value={formData?.pan_no}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Name on the Card'
                    name='name_on_the_card'
                    value={formData?.name_on_the_card}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isAadharCheck && (
              <>
                <h5>Aadhaar Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='Aadhar Number'
                    name='aadhar_no'
                    value={formData?.aadhar_no}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Registered Mobile Number'
                    name='registered_mobile_no'
                    value={formData?.registered_mobile_no}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isDlCheck && (
              <>
                <h5>Driving License Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='Driving License Number'
                    name='driving_license_no'
                    value={formData?.driving_license_no}
                    onChange={handleChange}
                  />
                  <input
                    type='date'
                    placeholder='Date of Birth'
                    name='dob'
                    value={formData?.dob}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isVoterCheck && (
              <>
                <h5>Voter Id Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='Father Name'
                    name='father_name'
                    value={formData?.father_name}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Voter Id Number'
                    name='voterid_no'
                    value={formData?.voterid_no}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isPassportCheck && (
              <>
                {" "}
                <h5>Passport Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='Passport Number'
                    name='passport_no'
                    value={formData?.passport_no}
                    onChange={handleChange}
                  />
                  <input
                    type='date'
                    placeholder='Date of Birth'
                    name='dob'
                    value={formData?.dob}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Given Name'
                    name='given_name'
                    value={formData?.given_name}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Surname'
                    name='surname'
                    value={formData?.surname}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Surname'
                    name='surname'
                    value={formData?.surname}
                    onChange={handleChange}
                  />
                  <select
                    name='gender'
                    value={formData?.gender}
                    onChange={handleChange}>
                    <option
                      value=''
                      disabled>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                  </select>
                  <input
                    type='text'
                    placeholder='Country Code'
                    name='country'
                    value={formData?.country}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='Passport Type'
                    name='passport_type'
                    value={formData?.passport_type}
                    onChange={handleChange}
                  />
                  <input
                    type='date'
                    placeholder='Expiry Date'
                    name='expiry_date'
                    value={formData?.expiry_date}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='MRZ1'
                    name='mrz1'
                    value={formData?.mrz1}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='MRZ2'
                    name='mrz2'
                    value={formData?.mrz2}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isBankCheck && (
              <>
                <h5>Bank Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='Account Number'
                    name='account_no'
                    value={formData?.account_no}
                    onChange={handleChange}
                  />
                  <input
                    type='text'
                    placeholder='IFSC Code'
                    name='ifsc_code'
                    value={formData?.ifsc_code}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {isUanCheck && (
              <>
                <h5>UAN Details</h5>
                <div className='InputContainer'>
                  <input
                    type='text'
                    placeholder='UAN Number'
                    name='uan_no'
                    value={formData?.uan_no}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            {insufficientCheckwiseData?.is_document_missing === 1 && (
              <>
                <span className='FileInput'>
                  <input
                    multiple
                    type='file'
                    id='FileInput'
                    accept='.jpeg, .jpg, .png, .pdf'
                    onChange={handleFileChange}
                  />
                  <label
                    htmlFor='FileInput'
                    className='FileInputLabel'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='20'
                      viewBox='0 0 16 20'
                      fill='none'>
                      <path
                        d='M11 6H15.4L10 0.6V5C10 5.6 10.4 6 11 6ZM11 8C9.3 8 8 6.7 8 5V0H3C1.3 0 0 1.3 0 3V17C0 18.7 1.3 20 3 20H13C14.7 20 16 18.7 16 17V8H11ZM5 6H6C6.6 6 7 6.4 7 7C7 7.6 6.6 8 6 8H5C4.4 8 4 7.6 4 7C4 6.4 4.4 6 5 6ZM11 16H5C4.4 16 4 15.6 4 15C4 14.4 4.4 14 5 14H11C11.6 14 12 14.4 12 15C12 15.6 11.6 16 11 16ZM11 12H5C4.4 12 4 11.6 4 11C4 10.4 4.4 10 5 10H11C11.6 10 12 10.4 12 11C12 11.6 11.6 12 11 12Z'
                        fill='white'
                      />
                    </svg>
                    <span>
                      Add{" "}
                      {isAadharCheck
                        ? "Aadhar"
                        : isBankCheck
                        ? "Bank"
                        : isDlCheck
                        ? "Driving license"
                        : isPanCheck
                        ? "PAN"
                        : isPassportCheck
                        ? "Passport"
                        : isUanCheck
                        ? "UAN"
                        : isVoterCheck
                        ? "Voter Id"
                        : ""}{" "}
                      documents
                    </span>
                  </label>
                </span>
                <div className='FileList'>
                  {!!files.length &&
                    files?.map((file, i) => {
                      const getFileName = (fileName) => {
                        const length = fileName?.split("/").length;
                        const name = fileName?.split("/")?.[length - 1];
                        return name;
                      };
                      const fileName =
                        typeof file === "string"
                          ? getFileName(file)
                          : file?.name;
                      return (
                        <div className='Document'>
                          <div className='DocumentName'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='18'
                              height='18'
                              viewBox='0 0 28 28'
                              fill='none'>
                              <path
                                fill-rule='evenodd'
                                clip-rule='evenodd'
                                d='M24.2096 9.81503C24.2096 9.2737 23.995 8.75453 23.6111 8.37186C22.4235 7.1842 18.4825 3.2432 17.2948 2.05553C16.9121 1.6717 16.393 1.45703 15.8516 1.45703C14.37 1.45703 9.81997 1.45703 7.0013 1.45703C6.1508 1.45703 5.33414 1.79536 4.73214 2.3962C4.1313 2.9982 3.79297 3.81486 3.79297 4.66536C3.79297 9.13603 3.79297 18.8614 3.79297 23.332C3.79297 24.1825 4.1313 24.9992 4.73214 25.6012C5.33414 26.202 6.1508 26.5404 7.0013 26.5404H21.0013C22.7735 26.5404 24.2096 25.1042 24.2096 23.332V9.81503ZM22.4596 9.81503V23.332C22.4596 24.137 21.8063 24.7904 21.0013 24.7904H7.0013C6.61397 24.7904 6.24414 24.6364 5.96997 24.3634C5.69697 24.0892 5.54297 23.7194 5.54297 23.332V4.66536C5.54297 4.27803 5.69697 3.9082 5.96997 3.63403C6.24414 3.36103 6.61397 3.20703 7.0013 3.20703H15.8516C15.9286 3.20703 16.0033 3.23736 16.0581 3.2922L22.3745 9.60853C22.4293 9.66336 22.4596 9.73803 22.4596 9.81503Z'
                                fill='black'
                              />
                              <path
                                fill-rule='evenodd'
                                clip-rule='evenodd'
                                d='M15.457 2.91797V7.0013C15.457 8.77347 16.8931 10.2096 18.6653 10.2096H22.7486C23.2316 10.2096 23.6236 9.81764 23.6236 9.33464C23.6236 8.85163 23.2316 8.45964 22.7486 8.45964H18.6653C17.8603 8.45964 17.207 7.8063 17.207 7.0013V2.91797C17.207 2.43497 16.815 2.04297 16.332 2.04297C15.849 2.04297 15.457 2.43497 15.457 2.91797ZM13.9986 10.793C12.2276 10.793 10.7903 12.2303 10.7903 14.0013C10.7903 15.7723 12.2276 17.2096 13.9986 17.2096C15.7696 17.2096 17.207 15.7723 17.207 14.0013C17.207 12.2303 15.7696 10.793 13.9986 10.793ZM13.9986 12.543C14.8036 12.543 15.457 13.1963 15.457 14.0013C15.457 14.8063 14.8036 15.4596 13.9986 15.4596C13.1936 15.4596 12.5403 14.8063 12.5403 14.0013C12.5403 13.1963 13.1936 12.543 13.9986 12.543ZM10.7145 21.44C11.3701 20.306 12.5963 19.543 13.9986 19.543C15.401 19.543 16.6271 20.306 17.2828 21.44C17.5255 21.8576 18.061 22 18.4786 21.7585C18.8963 21.517 19.0398 20.9803 18.7971 20.5626C17.8393 18.9071 16.0473 17.793 13.9986 17.793C11.95 17.793 10.158 18.9071 9.20014 20.5626C8.95747 20.9803 9.10097 21.517 9.51864 21.7585C9.9363 22 10.4718 21.8576 10.7145 21.44Z'
                                fill='black'
                              />
                            </svg>
                            <span>{fileName}</span>
                          </div>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            viewBox='0 0 30 30'
                            fill='none'
                            className='Delete'
                            onClick={() => handleDelete(i)}>
                            <path
                              d='M4.46023 5.98625H10.4602V5.22969C10.461 4.47329 10.7616 3.74805 11.2962 3.21293C11.8308 2.67782 12.5557 2.37649 13.3121 2.375H16.6871C17.4432 2.37698 18.1676 2.67853 18.7018 3.21359C19.236 3.74866 19.5364 4.47362 19.5371 5.22969V5.98625H25.5371C25.7857 5.98625 26.0242 6.08502 26.2 6.26084C26.3758 6.43665 26.4746 6.67511 26.4746 6.92375C26.4746 7.17239 26.3758 7.41085 26.2 7.58666C26.0242 7.76248 25.7857 7.86125 25.5371 7.86125H24.3821L23.5993 23.9984C23.5525 24.9767 23.1308 25.8995 22.4217 26.575C21.7126 27.2506 20.7706 27.6272 19.7912 27.6266H10.208C9.22863 27.6272 8.28659 27.2506 7.57748 26.575C6.86838 25.8995 6.44668 24.9767 6.39992 23.9984L5.61711 7.86594H4.46023C4.21159 7.86594 3.97314 7.76717 3.79732 7.59135C3.62151 7.41554 3.52273 7.17708 3.52273 6.92844C3.52273 6.6798 3.62151 6.44134 3.79732 6.26552C3.97314 6.08971 4.21159 5.99094 4.46023 5.99094V5.98625ZM17.6621 5.22969C17.6619 4.97074 17.5592 4.72241 17.3766 4.53887C17.1939 4.35533 16.946 4.25149 16.6871 4.25H13.3121C13.0532 4.25149 12.8053 4.35533 12.6227 4.53887C12.44 4.72241 12.3374 4.97074 12.3371 5.22969V5.98625H17.6621V5.22969ZM8.27305 23.9047C8.29668 24.4018 8.51093 24.8707 8.87128 25.2139C9.23163 25.5572 9.71038 25.7484 10.208 25.7478H19.7912C20.2888 25.7484 20.7676 25.5572 21.1279 25.2139C21.4883 24.8707 21.7025 24.4018 21.7262 23.9047L22.4996 7.86125H7.49023L8.27305 23.9047ZM11.8927 15.0228L13.674 16.8041L11.8927 18.5853C11.8032 18.6718 11.7318 18.7752 11.6826 18.8896C11.6335 19.004 11.6076 19.127 11.6066 19.2515C11.6055 19.376 11.6292 19.4994 11.6763 19.6146C11.7235 19.7299 11.7931 19.8345 11.8811 19.9226C11.9691 20.0106 12.0738 20.0802 12.189 20.1273C12.3042 20.1745 12.4277 20.1982 12.5522 20.1971C12.6767 20.196 12.7997 20.1702 12.9141 20.121C13.0284 20.0719 13.1319 20.0005 13.2184 19.9109L14.9996 18.1297L16.7809 19.9109C16.8673 20.0005 16.9708 20.0719 17.0852 20.121C17.1995 20.1702 17.3226 20.196 17.447 20.1971C17.5715 20.1982 17.695 20.1745 17.8102 20.1273C17.9254 20.0802 18.0301 20.0106 18.1181 19.9226C18.2061 19.8345 18.2757 19.7299 18.3229 19.6146C18.37 19.4994 18.3937 19.376 18.3927 19.2515C18.3916 19.127 18.3657 19.004 18.3166 18.8896C18.2674 18.7752 18.196 18.6718 18.1065 18.5853L16.3252 16.8041L18.1065 15.0228C18.2824 14.847 18.3813 14.6086 18.3814 14.3599C18.3814 14.1112 18.2827 13.8726 18.107 13.6967C17.9312 13.5208 17.6927 13.4219 17.444 13.4218C17.1953 13.4218 16.9568 13.5205 16.7809 13.6963L14.9996 15.4775L13.2184 13.6963C13.0415 13.5255 12.8047 13.431 12.5589 13.4331C12.3131 13.4353 12.078 13.5339 11.9042 13.7077C11.7303 13.8815 11.6317 14.1166 11.6296 14.3624C11.6275 14.6082 11.722 14.846 11.8927 15.0228Z'
                              fill='white'></path>
                          </svg>
                        </div>
                      );
                    })}
                </div>
              </>
            )}
          </section>
        </form>
      )}
    </main>
  );
};

export default AddInsufficiencyIdVendor;